import { DrawioEditorPage as PlatformDrawioEditorPage } from '@jarvis/platform-ui';

export function DrawioEditorPage() {
  return <PlatformDrawioEditorPage filesLinkTo="/files" filesLinkLabel="Files" />;
}
